/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const getOwnDutyCalendarParamsDisplayTimeZoneMax = 100;

export const getOwnDutyCalendarParamsReferenceDateRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))$',
);
export const getOwnDutyCalendarParamsRangeDefault = `two-weeks`;
export const GetOwnDutyCalendarParams = zod.object({
  displayTimeZone: zod.string().min(1).max(getOwnDutyCalendarParamsDisplayTimeZoneMax),
  referenceDate: zod.iso.date().regex(getOwnDutyCalendarParamsReferenceDateRegExp),
  range: zod
    .enum(['one-day', 'one-week', 'two-weeks', 'one-month'])
    .default(getOwnDutyCalendarParamsRangeDefault),
});

export type GetOwnDutyCalendarParams = zod.input<typeof GetOwnDutyCalendarParams>;
export type GetOwnDutyCalendarParamsOutput = zod.output<typeof GetOwnDutyCalendarParams>;
